<template>
	<div v-if="isActive">
		<div class="card mb-4">
			<div class="card-header">
				{{ title }}
			</div>
			<div class="card-body">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: "Tab",
		},
		id: String,
	},
	data() {
		return {
			isActive: true,
		};
	},
};
</script>
